// extracted by mini-css-extract-plugin
export default {"markableWrapper":"markable_markableWrapper__Dhu5N","canvas":"markable_canvas__jj9QI","markable":"markable_markable__cHec1","markingMode":"markable_markingMode__pkUcX"};